import React, { FunctionComponent, useEffect, useState } from 'react';
import { css } from '@emotion/core';
import t from 'react-translate';
// redux
import { useSelector } from 'react-redux';
// spaces and styles
import { halfSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';
import { handheld } from 'styles/global_defaults/media-queries';
// components
import { RootState } from 'redux/schemas';
import { addSkillTag, getSkillTags } from 'redux/actions/skill-tags';
import { SkillTagsNormalized } from 'redux/schemas/api/skill-tag';
import LoadingWrapper, { LoaderType } from 'shared/components/loading-wrapper';
import { useAppDispatch } from 'redux/store';
import NVAddItem from '../../shared/components/nv-add-item';
import { NVBasicTable, BasicTableColumn, ColumnType, SortType } from '../../shared/components/nv-basic-table';
import SkillRow from './skill-row';
import { config } from '../../../config/pendo.config.json';

// types
type HeaderProps = {
  total: number
};

// styles
const styles = css`
  &.skill-tags{
    ${handheld(css`
      padding: 0 ${standardSpacing}px 0 ${standardSpacing}px;
    `)};
    .column-centered{
      justify-content:center;
    }
    .skill-row{
      padding: ${halfSpacing}px 0 ${halfSpacing}px 0;
    }
  }
  `;

const DashboardHeader = (props: HeaderProps) => (
  <div className='title'>
    <div className='page-subtitle text-center'>
      {t.INSTITUTIONS.SKILL_TAGS.HEADER()} {props.total > 0 && `(${props.total})`}
    </div>
    <div className='description mt-2'>
      {t.INSTITUTIONS.SKILL_TAGS.DESCRIPTION()}
    </div>
  </div>
);
export const getColumns = () => {
  const cols: BasicTableColumn[] = [
    {
      key: 'name',
      name: t.INSTITUTIONS.SKILL_TAGS.SKILL_NAME(),
      className: 'column',
      sortable: true,
      gridWidth: '2fr',
      type: ColumnType.STRING,
    },
    {
      key: 'activitiesTagged',
      name: t.INSTITUTIONS.SKILL_TAGS.ACTIVITIES_TAGGED(),
      className: 'column-centered',
      sortable: true,
      gridWidth: '1fr',
      type: ColumnType.NUMBER,
    },
    {
      key: 'coursesTagged',
      name: t.INSTITUTIONS.SKILL_TAGS.COURSES_TAGGED(),
      className: 'column-centered',
      sortable: true,
      gridWidth: '1fr',
      type: ColumnType.NUMBER,
    },
  ];
  return cols;
};
const SkillTagsDashboard = (props) => {
  const [lastAdded, setLastAdded] = useState(null);
  const dispatch = useAppDispatch();
  const isLoading = useSelector((state) => state.app.skillTag.isLoading);
  const currentInstitutionId = useSelector(
    (state: RootState) => state.app.currentInstitutionId,
  );
  const errorMessage = { message: t.INSTITUTIONS.SKILL_TAGS.ALREADY_EXISTS_ERROR() };
  const tags = useSelector((state) => state.models.skillTags);
  const total = Object.keys(tags).length;
  useEffect(() => {
    dispatch(getSkillTags({ institutionId: currentInstitutionId }));
  }, []);

  useEffect(() => {
  }, [isLoading]);


  const onAddTag = async (value) => {
    const result = await dispatch(addSkillTag({ institutionId: currentInstitutionId, tag: { name: value } }));
    if (result.payload?.error) {
      return false;
    }
    setLastAdded(result.payload?.id);
    return true;
  };

  const overwritestyles = css`
  .&add-item-container{
    background-color:red;
  }
  `;

  return (
    <div css={styles} className='skill-tags body-text-wrapper'>
      {/* <SkillsTags lectureComponentId='14' lectureComponentName='QuizLectureComponent' lecturePageId='4' catalogId='local_course3' /> */}
      <DashboardHeader total={total} />
      <NVAddItem
        css={overwritestyles}
        onSave={onAddTag}
        errorMessage={errorMessage}
        icon='icon-create-new-post'
        buttonLabel={t.INSTITUTIONS.SKILL_TAGS.ADD_SKILL()}
        showConfirmation
        confirmationMessage={t.INSTITUTIONS.SKILL_TAGS.CONFIRMATION}
        placeholder={t.INSTITUTIONS.SKILL_TAGS.PLACEHOLDER()}
        maxLength={50}
        pendoTag={config.pendo.skillTags.addSkill}
      />

      {Object.keys(tags).length > 0
      && (
        <LoadingWrapper isLoaded={!isLoading} loaderType={LoaderType.PLACEHOLDER}>
          <NVBasicTable<JSX.Element, SkillTagsNormalized>
            columns={getColumns()}
            tabledata={tags}
            rowComponent={SkillRow as FunctionComponent}
            rowClass='skill-row'
            highlightClass='row-added'
            highlightId={lastAdded}
            defaultSort={{ name: 'name', type: SortType.ASC }}
          />
        </LoadingWrapper>
      )}
    </div>
  );
};
export default SkillTagsDashboard;
